import { createReducer, on } from "@ngrx/store";
import { AggregateReportState, initialAggregateReportState } from "./aggregate-report.state";
import { GetStatisticsTableLength, GetStatisticsTableLengthSuccess, ResetStatisticsState, ResetStatisticsTables, ResetStatisticsTablesSuccess } from "./aggregate-report.actions";

export const AggregateReportReducers = createReducer(
  initialAggregateReportState,
  on(ResetStatisticsState, (state): AggregateReportState => {
    return initialAggregateReportState;
  }),
  on(GetStatisticsTableLength, (state): AggregateReportState => {
    return {
      ...state,
      loader: true
    }
  }),
  on(GetStatisticsTableLengthSuccess, (state, action): AggregateReportState => {
    return {
      ...state,
      loader: false,
      length: action.result
    }
  }),
  on(ResetStatisticsTables, (state): AggregateReportState => {
    return {
      ...state,
      loader: true
    }
  }),
  on(ResetStatisticsTablesSuccess, (state, action): AggregateReportState => {
    return {
      ...state,
      loader: false,
      length: 0,
      resetResult: action.result
    }
  }),
)